import { Menu, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Fragment } from 'react';
import tw, { styled } from 'twin.macro';

import ChevronIcon from '~/shared/assets/icons/chevron.svg';

const ItemsContainer = tw(Menu.Items)`
   absolute right-1 top-[28px] origin-top-right font-light
   rounded-md w-max bg-white
   shadow-lg focus:outline-none z-50 border border-primary-300
 ` as typeof Menu.Items;

const MenuBtn = styled.button<{
  $active: boolean;
}>(({ $active }) => [
  tw`text-[14px] leading-6 mb-1 text-black
  w-full flex rounded-md px-2 py-[2px]`,
  $active ? tw`` : '',
]);

const transitionProps = {
  enter: 'transition ease-out duration-100',
  enterFrom: 'transform opacity-0 scale-95',
  enterTo: 'transform opacity-100 scale-100',
  leave: 'transition ease-in duration-75',
  leaveFrom: 'transform opacity-100 scale-100',
  leaveTo: 'transform opacity-0 scale-95',
};

function ChartFilterDropdown<T extends { title: string }>({
  items,
  onSelect,
  selectedItemIndex = 0,
}: {
  onSelect: (selection: T) => void;
  items?: {
    title: string;
    fn: () => T;
  }[];
  selectedItemIndex?: number;
}) {
  const selectedItem = items?.[selectedItemIndex];

  const onClick = (item: typeof selectedItem) => {
    onSelect(item?.fn() as T);
  };

  return (
    <Menu as="div" className="relative flex">
      <Menu.Button className="bg-white text-primary-900 border border-primary-500 flex justify-between w-[203px] rounded-[8px] px-[16px] py-[12px]">
        {({ open }) => (
          <>
            <div className="font-normal text-[16px] leading-[20px] text-[#544A4A]">
              {selectedItem?.title}
            </div>

            <ChevronIcon
              className={clsx('fill-[#1D1D1D]', open ? 'rotate-180' : '')}
              width={16}
              height={16}
            />
          </>
        )}
      </Menu.Button>

      <Transition as={Fragment} {...transitionProps}>
        <ItemsContainer>
          <div className="p-1">
            {items?.map((item) => (
              <Menu.Item key={item.title}>
                {({ active }) => (
                  <MenuBtn onClick={() => onClick(item)} $active={active}>
                    {item.title}
                  </MenuBtn>
                )}
              </Menu.Item>
            ))}
          </div>
        </ItemsContainer>
      </Transition>
    </Menu>
  );
}

export default ChartFilterDropdown;
